import { SliceCaseReducers } from '@reduxjs/toolkit'
import { ProductOperationDetailParams, ProductOperationDetailResponse } from '@repo/accounts-types'
import { createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ProductOperationDetailResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const {
  actions: productOperationDetailDataActions,
  reducer: productOperationDetailDataReducer,
} = createOperationSlice<
  ProductOperationDetailResponse | null,
  SliceCaseReducers<GenericOperationState<ProductOperationDetailResponse | null>>,
  ProductOperationDetailParams
>({
  name: '@accounts/detail/read/fund/operationDetail',
  initialState,
  reducers: {},
})
